import { Settings2FAContext } from "../types/Settings2FAContext";
import { Settings2FAEvent } from "../types/Settings2FAEvent";

export const set2FAStatusAction = (
  _context: Settings2FAContext,
  event: Settings2FAEvent
): Partial<Settings2FAContext> => {
  if (event.type !== "STATUS_LOADED") {
    throw new Error("Invalid event type");
  }
  return {
    is2FAEnabled: event.is2FAEnabled,
    userId: event.userId,
  };
};
